import { ClickEvent, DataDisplayEvent, DataSourceAction, DataSourceExecutionEvent, Label } from "@mcleod/components";
import { PlanningUtil } from "../planning/PlanningUtil";
import { AutogenLayoutDispatchNext } from "./autogen/AutogenLayoutDispatchNext";
import { StopList } from "../StopList";
import { StopProgress } from "../StopProgress";
import { StopUtil } from "../StopUtil";
import { TrailerUtil } from "../TrailerUtil";

export class DispatchNext extends AutogenLayoutDispatchNext {

    onLoad(): void | Promise<void> {
        this.labelOrderId.addUnderlineWhenMouseOver();
        TrailerUtil.setupMaxTrailers(this.textboxTrailerId, this.panelTrailer2, this.panelTrailer3);
    }

    sourceMovementAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            this.sourceEquipmentGroup.search({ id: this.activeRow.get("equipment_group_id") });
            (this.layoutStopProgress as StopProgress).setStopsTable((this.layoutStopList as StopList).tableStop);
            this.setupEtaPanel();
        }
    }

    sourceStopAfterExecution(event: DataSourceExecutionEvent) {
        const origin = this.sourceStop.data[0];
        this.textboxDriverLoadUnload.text = origin.getLookupModelData("driver_load_unload")[0].get("descr");
    }

    orderNumberOnClick(event: ClickEvent) {
        PlanningUtil.navigateToOrder(event);
    }

    labelOrderWeightOnDataDisplay(event: DataDisplayEvent) {
        const labelWeight = event.target as Label;
        const row = event.rowData;
        if (row && !row.isNull("orders.weight")) {
            labelWeight.text = `${row.get("orders.weight")} ${row.get("orders.weight_um")}`;
        }
    }

    private setupEtaPanel() {
        const modelRow = this.sourceMovement.activeRow;
        if (!modelRow) {
            return;
        }
        const labelOriginLateStatus = this.labelLateStatus;
        const originLateStatus = modelRow.getString("stop_origin.late_route_status");
        const panel = this.panelLateStatus;
        const bgColor = modelRow.getString("origin_late_eta_color");

        this.labelEtaCaption.visible = !modelRow.isNull("stop_origin.eta")
            || !modelRow.isNull("origin_dist_to_pickup") || !modelRow.isNull("stop_origin.late_route_status");
        StopUtil.setupOriginLateStatusPanel(panel, labelOriginLateStatus, originLateStatus, bgColor);
    }

    sourceEquipmentGroupAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            const equipmentGroupSummary = this.sourceEquipmentGroup.summaryData;
            if (equipmentGroupSummary) {
                this.activeRow.setValues(equipmentGroupSummary.data);
            }
        }
    }

}
